import styled from 'styled-components';
import {
  ButtonBase,
  BaseColumnWrap,
} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

export const CartInnerWrapperDiv = styled.div(
  props => `
    position:sticky;
    left: 0;
    // bottom: ${!props.isFilterExists ? '343px' : '240px'};
    // align-self: flex-end;
    top: 260px;
    width: 100%;
    height: calc(100vh - 280px);
    overflow: scroll;
    &::-webkit-scrollbar {
       display: none;
    }
    `,
);

export const CartStickyHeaderDiv = styled.div(
  props => `
    display:flex;
    width:100%;
    flex-direction:column;
    background:${props.isGuestFilled ? '#d3f2d6' : '#ffebee'};
    padding:${props.theme.spacing.small} ${props.theme.spacing.base};
    position: sticky;
    top: ${
      props.isUpSellFlow
        ? `calc(214px + ${props.filterHeight}px)`
        : `calc(209px + ${props.filterHeight}px)`
    };
    z-index: 1;
    `,
);

export const CartContainerWrapper = styled.div(
  props => `
    // width:${props.isNoInclusion ? '25%' : '20%'};
    width:'100%';

    display:flex;
    // flex-direction: column;
    border-left: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
    background-color: #eef4fd;
    flex:1;
    // position:sticky;
    // top:20.8rem;
  `,
);

export const CartMainContainerWrapper = styled.div(
  props => `
    width:100%;
    display:flex;
    flex-direction:column;
    padding: ${props.theme.spacing.large};
  `,
);

export const CartRoomDetailsBlockDiv = styled.div(
  props => `
    width:100%;
    display:flex;
    flex-direction:column;
    padding: ${props.theme.spacing.large};
    border-radius: ${props.theme.misc.borderRadius.large};
    border:0.1rem solid #dcddde;
    margin-bottom: 1.5rem;
    background-color: ${props.theme.colors.goWhite.base};
    `,
);

export const RoomDetailsDiv = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
  `,
);

export const PropertyTypePara = styled.p(
  props => `
    font-size:${props.theme.font.custom(14)};
    font-weight: 600;
    padding-bottom:${props.theme.spacing.base};
    `,
);

export const PaxDetailsDiv = styled.div(
  props => `
    display:
    width:100%;
    flex-direction:column;
    margin-bottom: ${props.theme.spacing.base};
    // margin-right: ${props.theme.spacing.base};
    border-left:.3rem solid ${props.theme.colors.ash.dark};
    `,
);

export const PaxDetailsInnerDiv = styled(BaseColumnWrap)(
  props => `
    padding-left:${props.theme.spacing.base};
    `,
);

export const TotalPaxCountSpan = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color:#5d5d5d;
    `,
);

export const AmenitiesDetailsWrapper = styled.div(
  props => `
    padding-top:${props.theme.spacing.base};
    display:flex;
    flex-direction:row;
  `,
);

export const MealsSpan = styled.span(
  props => `
    padding-right:${props.theme.spacing.base};
    font-size:${props.theme.font.custom(12)};
  
    
  `,
);

export const RedAlertSpan = styled.span(
  props => `
    font-size:${props.theme.font.custom(12)};
    color:${props.theme.colors.goRed.base};
  `,
);

export const GreenAlertSpan = styled.span(
  props => `
    font-size:${props.theme.font.custom(14)};
    color:${props.theme.colors.goGreen.base};
  `,
);

export const TaxAndInclusionPara = styled.p(
  props => `
    display:flex;
    flex-direction:column;
    padding-bottom: ${props.theme.spacing.base};
  `,
);

export const UpgradeDowngradeBtn = styled.span`
  ${textSizes.LargeW3}
  width:60%;
  display: flex;
  padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.base};
  border: 1px solid ${props => props.theme.colors.ash.dark};
  border-radius: ${props => props.theme.misc.borderRadius.custom(20)};
  box-shadow: 0 0.8rem 0.6rem -0.6rem ${props => props.theme.colors.shadow.light};
  color: ${props => props.theme.colors.goBrandBlue.base};
  align-items: center;
  justify-content: space-around;
`;

export const BookRoomWrapperDiv = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    border-top:1px solid #dcddde;
    align-items: flex-end;
  `,
);

export const StrickedPricePara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(12)};
    color: ${props.theme.colors.ash.base};
    text-decoration: line-through;
    padding-bottom: ${props.theme.spacing.small};
    padding-top: ${props.theme.spacing.base};
    `,
);

export const OriginalPricePara = styled.p`
  ${textSizes.MediumW3}
  padding-bottom: ${props => props.theme.spacing.small};
`;

export const TaxInclusionPara = styled.p`
  padding-bottom: ${props => props.theme.spacing.small};
`;

export const RoomsAvailablePara = styled.p(
  props => `
    color: ${props.theme.colors.ash.base};
    padding-bottom: ${props.theme.spacing.small};
  `,
);

export const ComboBtn = styled(ButtonBase)`
  ${textSizes.MediumW3}
  flex-direction: column;
  border-radius: 5rem;
  width: 100%;
  padding: ${props => props.theme.spacing.base};
  margin-top: ${props => props.theme.spacing.base};
`;

export const TotalPaxCountBtnSpan = styled.span(
  props => `
    color: ${props.theme.colors.goWhite.base};
  `,
);

export const FlexWrap = styled.div(
  props => `
        display:flex;
        `,
);

export const LessOccupnacyModalContent = styled.div(
  props => `
  padding: 2rem;
`,
);

export const LessOccupnacyModalInfoText = styled.p(
  props => `
font-size: 1.6rem;
padding: 0 0 0 1rem;
position: relative;
`,
);

export const RoomSelectedListWrapper = styled.ul(
  props => `
    
`,
);

export const RoomSelectedItem = styled.li(
  props => `

display: flex;
    align-items: center;
    padding-top: 10px;
    margin-left: 13px;
`,
);

export const BulletPoint = styled.span(
  props => `
    background-color:${props.theme.colors.downriver.base};
    // border-radius: ${props.theme.misc.borderRadius.xxxlarge};

    border-radius: 50%;
    width: 0.6rem;
    height: 0.6rem;
    margin-right: ${props.theme.spacing.small};
    `,
);

export const BulletTextSpan = styled.span(
  props => `
    font-size:${!props.isMultiRoom ? props.theme.font.custom(14) : '12px'};
    `,
);

export const BulletPointOuter = styled.div(
  props => `
    display:flex;
    width:4%;
    `,
);

export const BulletTextOuter = styled.span(
  props => `
    display:flex;
    width:95%;
    `,
);

export const AlertSpan = styled.span(
  props => `
  color: #FF3A5C;
  font-weight: 600;
`,
);

export const ModalActionContainer = styled.div(
  props => `
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top:30px;
  align-items:center
`,
);

export const ContinueAwayButton = styled(ButtonBase)(
  props => `
    font-size:16px;
    border-radius: ${props.theme.misc.borderRadius.custom(30)};
    box-shadow: 0 0.2rem 1.2rem 0 ${props.theme.colors.shadow.light};
    bottom: -3rem;
    width: 199px;
    height: 48px;
    display:block;
  `,
);

export const ButtonGuestCount = styled.p`
  ${textSizes.SmallW1}
`;

export const EditSelectionButton = styled.div`
  ${textSizes.BaseW3}
  color:${props => props.theme.colors.goBrandBlue.base};
  margin-right: 16px;
  cursor: pointer;
`;

export const StickyHeaderLoader = styled.div(
  props => `
  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:100%;
  height:1.8rem;
`,
);

export const StickyHeaderLoaderWrapper = styled.div(
  props => `
    display:flex;
    width:100%;
    flex-direction:column;
    background-color:white;
    padding:${props.theme.spacing.small} ${props.theme.spacing.base};
    position: sticky;
    top: ${
      props.isUpSellFlow
        ? `calc(225px + ${props.filterHeight}px)`
        : `calc(209px + ${props.filterHeight}px)`
    };
    z-index: 1;
    `,
);

export const FitRoomText = styled.strong(
  props => `
    text-transform:capitalize;
    `,
);
